import { render, staticRenderFns } from "./AnualCalendar.vue?vue&type=template&id=faf3d030&scoped=true"
import script from "./AnualCalendar.vue?vue&type=script&lang=js"
export * from "./AnualCalendar.vue?vue&type=script&lang=js"
import style0 from "./AnualCalendar.vue?vue&type=style&index=0&id=faf3d030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf3d030",
  null
  
)

export default component.exports